import React from 'react'
import CallToAction from './CallToAction'
import { FormattedMessage } from 'react-intl'

const BubbleOutline = ({className, width, title, children, link, more, moreText }) => {
  return (
    <div className={className}>
      <div
        className="bubble-outline"
        style={{ width: width }}
      >
        <h4 className="text-3xl md:text-4xl mb-2 text-shadow">{title}</h4>
        <div className="md:text-xl leading-normal text-white text-shadow">{children}</div>

        {
          !more ? null : (
            <div className="text-center">
              <CallToAction link={link}
                className="border-2 border-white hover:bg-white text-white hover:text-black"
              >
                <span className="uppercase">{moreText}</span>
              </CallToAction>
            </div>
          )
        }
      </div>
    </div>
  )
}

BubbleOutline.defaultProps = {
  className: '',
  width: "100%",
  title: "[Title]",
  children: "[Content]",
  link: "",
  more: false,
  moreText: <FormattedMessage id="more" />,
}

export default BubbleOutline
